import { useQuery, QueryKey, UseQueryOptions } from 'react-query'
import qs from 'qs'

import api from 'api/index'
import type { ApiError } from 'api/types/ApiError'
import { ApiPaginationQuery } from 'api/types/ApiPaginationQuery'
import { ApiMeta } from 'api/types/ApiMeta'
import { CheckupLogListItem } from 'types/domain/CheckupLog'

import { CHECKUP_LOGS_ENDPOINT_KEY } from './constants'

export type GetCheckupListResourceRequestQuery = ApiPaginationQuery & {
  hotel_name?: string
  requester?: string
  date_from?: string
  date_to?: string
}

export type GetCheckupListResourceResponse = {
  data: Array<CheckupLogListItem>
  meta: ApiMeta
}

export const getCheckupListResource = ({
  query,
}: {
  query: GetCheckupListResourceRequestQuery
}): Promise<GetCheckupListResourceResponse> =>
  api.get(`/${CHECKUP_LOGS_ENDPOINT_KEY}?${qs.stringify(query, { skipNulls: true })}`)

export const useGetCheckupListResource = ({
  query,
  queryOptions,
  customQueryKey,
}: {
  query: GetCheckupListResourceRequestQuery
  queryOptions?: UseQueryOptions<Awaited<ReturnType<typeof getCheckupListResource>>, ApiError>
  customQueryKey?: QueryKey
}) =>
  useQuery(
    customQueryKey || [CHECKUP_LOGS_ENDPOINT_KEY, 'list', ...Object.values(query || {})],
    () => getCheckupListResource({ query }),
    queryOptions,
  )
